var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEllipseFilled = function SvgEllipseFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.871 11.187C.264 6.956.534.085 10.345.326S25.831 5.18 26.438 9.411s-1.01 9.104-7.69 10.062S2.36 15.837.871 11.187"
  })));
};
export default SvgEllipseFilled;